import '../scss/contacts.scss';

import menuModule from "./modules/menu.js";
import scrollUpModule from "./modules/scrollUpModule.js";
import footerModule from "./modules/footerModule.js";
import contactFormModule from "./modules/contactFormModule.js";

(function ($) {


    $(document).ready(function () {
        window.$ = jQuery;

        menuModule.init();
        scrollUpModule.init();
        footerModule.init();
        contactFormModule.init();


    });
}(jQuery));



